import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "./header.css"

const Header = () => {
  return (
    <header className="header">
      <nav className="nav-menu">
        <Link to="/vita" className="nav-item" activeClassName="nav-active">
          vita
        </Link>
        <Link
          to="/exhibitions"
          className="nav-item"
          activeClassName="nav-active"
        >
          shows
        </Link>
        <a
          href="https://www.instagram.com/camillvonegloffstein/"
          className="nav-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          insta
        </a>
        <a href="mailto:camillvegloffstein@icloud.com" className="nav-item">
          mail
        </a>
      </nav>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: "",
}

export default Header
